// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueDateRangePicker.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * range datetime picker component
 */

import React, {PropTypes} from 'react';
import DateTimePicker from 'share/components/controls/DateTime/Izenda.DateTimePicker';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import { isEmpty } from 'lodash/fp';

const OperatorValueDateRangePicker = (props: any) => {
  const onChangeDateRange = newRange => {
    props.onChange(newRange);
  };
  const filterInfo = props.filterInfo || {};
  const lessThanDateString = filterInfo.value && filterInfo.value[0];
  const greaterDateString = filterInfo.value && filterInfo.value[1];
  let dateRangeValue = [];
  if (isEmpty(lessThanDateString) && isEmpty(greaterDateString)) {
    dateRangeValue = undefined;
  } else {
    dateRangeValue = [lessThanDateString, greaterDateString];
  }
  return (
    <GridLayout className='Izenda__TwoDatePickers'>
      <DateTimePicker
        onChange={onChangeDateRange}
        value={dateRangeValue}
        disabled={props.disabled}
        time={props.time}
        calendar={props.calendar}
        renderInContainer={props.renderInContainer}
        hasRange
      />
    </GridLayout>
  );
};
const propTypes = {
  filterInfo: PropTypes.object.isRequired
};
OperatorValueDateRangePicker.propTypes = propTypes;

export default OperatorValueDateRangePicker;



// WEBPACK FOOTER //
// ./ui/modules/OperatorValue/Izenda.OperatorValueDateRangePicker.js